import React from 'react';
import { AgentWorkspace } from '../components/AgentWorkforce';

const AIEmployeeWorkspace = () => {
  return <AgentWorkspace />;
};

export default AIEmployeeWorkspace; 